import React from 'react'
import styled from 'styled-components'
import { ErrorMessage, Field } from 'formik'
import FormErrorMessage from 'components/form-components/FormErrorMessage'
import colors from '../../styles/colors'

const InputBlock = styled.div`
  margin-bottom: 10px;
`

const InputWrap = styled.div`
  position: relative;
  z-index: 0;
`

const RadioButton = styled.label`
  display: inline-block;
  min-width: 100px;
  padding-left: 40px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 300;
  position: relative;
  margin-right: 36px;
  cursor: pointer;
  z-index: 0;
  margin-bottom: 10px;
  user-select: none;

  &:hover {
    opacity: 0.9;
  }

  & input {
    width: 0;
    height: 0;
    position: absolute;
    left: -1px;
    top: -1px;

    &:checked + span:before {
      display: block;
    }
    &:checked + span:after {
      border-color: ${colors.greenMain};
    }
  }

  & span {
    &:after {
      box-sizing: border-box;
      position: absolute;
      content: '';
      left: 0;
      top: 0;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: 1px solid #e8ecf3;
      background-color: ${colors.white};
    }

    &:before {
      position: absolute;
      content: '';
      left: 12px;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: ${colors.greenMain};
      z-index: 1;
      display: none;
    }
  }
`

const FormRadio = ({ name, options }) => (
  <InputBlock>
    <InputWrap>
      {options.map(({ label, value }, key) => (
        <RadioButton key={key}>
          <Field type="radio" name={name} value={value} />
          <span>{label}</span>
        </RadioButton>
      ))}
    </InputWrap>
    <ErrorMessage component={FormErrorMessage} name={name} />
  </InputBlock>
)

export default FormRadio
